/**
 * Default: Page starts at 0.
 */
export const getOffset = (
  page: number,
  size: number,
  notZeroIndexed?: boolean,
): number => {
  return page * size + (notZeroIndexed ? 1 : 0);
};
